import * as React from 'react'
import { useLocation } from 'react-router-dom';

export const LoggedOut = (props: any) => {
    const location = useLocation()
    const urlParams = new URLSearchParams(location.search);
    const saml = urlParams.get('SAMLResponse');

    React.useEffect(() => {
        if(saml){
            window.location.assign('/login');
            return null;
        }
    }, [saml])
    
    return(
        <>
        <h2 style={{margin: 10}}>Successfully logged out!</h2>
        <h4 style={{margin: 10}}>You can close this window.</h4>
        </>
    )
}